import React from 'react';
import cn from 'classnames';

import { CheckCircleIcon } from '../../icons';
import styles from './DeviceInfo.module.scss';

const DeviceInfo = ({ device, className = '' }) => {
  return (
    <div className={cn(styles.deviceInfo, className)}>
      <div className={styles.deviceInfoRow}>
        <div className={styles.deviceInfoColumnTitle}>ID</div>
        <div className={styles.deviceInfoColumnValue}>{device?.id}</div>
      </div>
      <div className={styles.deviceInfoRow}>
        <div className={styles.deviceInfoColumnTitle}>NAME</div>
        <div className={styles.deviceInfoColumnValue}>{device?.name || '—'}</div>
      </div>
      <div className={styles.deviceInfoRow}>
        <div className={styles.deviceInfoColumnTitle}>STATUS</div>
        <div className={styles.deviceInfoColumnValue}>
          {device?.gatt?.connected ? (
            <>
              Connected <CheckCircleIcon style={{ marginLeft: '10px' }} />
            </>
          ) : (
            '—'
          )}
        </div>
      </div>
    </div>
  );
};

export default DeviceInfo;
